var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-date-time-field',_vm._g(_vm._b({attrs:{"value":_vm.value,"label":_vm.field.title,"rules":_vm.rules,"required":_vm.required}},'app-date-time-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }